import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 2rem;
  margin-top: 0.4rem;
`

export const StyledCol = styled.div`
  display: flex;
  width: max-content;
  color: ${themeStyles.colors.lightGreys[4].main};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
`
